import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto flex min-h-[60vh] max-w-[1280px] flex-col items-center justify-center px-4 py-20 text-center md:px-6">
      <p className="font-heading text-7xl font-extrabold text-primary-200 md:text-9xl">404</p>
      <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
        页面走丢了
      </h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
        你要找的页面可能已被移动或不存在。当前路径：
        <span className="ml-1 font-mono text-xs text-foreground-500">{location.pathname}</span>
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line" aria-hidden="true"></i>
          返回首页
        </Link>
        <Link
          to="/category/movie"
          className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-6 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-200"
        >
          <i className="ri-film-line" aria-hidden="true"></i>
          浏览电影
        </Link>
      </div>
    </div>
  );
}